export function removeDiacritics(str: string) {
  return str.normalize("NFD").replace(/[\u0300-\u036f\W]/g, "");
}


export function filterSelectedList<T extends GenericObject>(list: T[], value: string, propertyNames: Array<(keyof T)>) {
  if (!value) {
    return [...list];
  }

  return searchArray(list, propertyNames, value)
}

type GenericObject = { [key: string]: any }

export function searchArray<T extends GenericObject>(array: T[], keys: Array<(keyof T)>, searchValue: string) {
  const searchValueNormalized = removeDiacritics(searchValue.toLowerCase());

  const regex = new RegExp(searchValueNormalized, "i");

  return array.filter(item => {
    return keys.some(key => {
      const attributeValueNormalized = removeDiacritics(item[key].toLowerCase());
      return regex.test(attributeValueNormalized);
    });
  });
}
